import * as React from "react";

import { AppShape } from "@eave/shared/types/api";
import classnames from "classnames";
import APIClient from "../APIClient";

require("../../assets/stylesheets/components/underwriter_dashboard/aan.scss");

const { FormattedDate } = require("react-intl");
import { Modal, Button, Select, SelectItem, TextInput } from "carbon-components-react";
import { AANOptions, aansOptions } from "web_modules/forms/data/aans";

interface AANProps {
  app: AppShape;
  dispatch?: Function;
}

class AAN extends React.Component<AANProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      aans: [],
      modalIsOpen: false,
      selectedAAN: "",
      AANOtherNotes: "",
    };
  }

  componentDidMount() {
    this.getAANs();
  }

  aANHasBeenSent() {
    return this.state.aans.filter(aan => aan.confirmed_at).length > 0;
  }

  getAANs() {
    APIClient.get(`/${this.props.app.id}/aans`).then((responseObject: any) => {
      if (responseObject.aans) {
        this.setState({ aans: responseObject.aans });
      }
    });
  }

  setAAN(reason, otherNotes: string) {
    const reasonWithNotes = otherNotes === "" ? reason : `${reason} - ${otherNotes}`;
    APIClient.post(`/${this.props.app.id}/aans`, {
      reasons: [reasonWithNotes],
    }).then((responseObject: any) => {
      if (responseObject.aans) {
        this.setState({
          aans: responseObject.aans,
          modalIsOpen: false,
          AANOtherNotes: "",
        });
      }
    });
  }

  confirmAAN(id, confirmed) {
    APIClient.put(`/${this.props.app.id}/aans/${id}`, { confirmed }).then((responseObject: any) => {
      if (responseObject.aans) {
        this.setState({ aans: responseObject.aans });
      }
    });
  }

  deleteAAN(id) {
    APIClient.deleteRequest(`/${this.props.app.id}/aans/${id}`).then((responseObject: any) => {
      if (responseObject.aans) {
        this.setState({ aans: responseObject.aans });
      }
    });
  }

  render() {
    const headerClassNames = classnames({
      "hurdles-editor__group-name": true,
      "hurdles-editor__aan_sent": this.aANHasBeenSent(),
    });

    const { modalIsOpen, selectedAAN, AANOtherNotes } = this.state;

    return (
      <>
        <Modal
          open={modalIsOpen}
          primaryButtonText="Save"
          primaryButtonDisabled={
            selectedAAN === "" || (selectedAAN === AANOptions.OTHER && AANOtherNotes === "")
          }
          onRequestClose={() => {
            this.setState({ modalIsOpen: false });
          }}
          onRequestSubmit={e => {
            this.setAAN(selectedAAN, AANOtherNotes);
          }}
          secondaryButtonText="Cancel"
        >
          <Select
            key="something"
            id="id"
            name="aans-options"
            labelText="Choose an option below"
            value={selectedAAN}
            onChange={e =>
              this.setState({
                selectedAAN: e.target.value,
                AANOtherNotes: e.target.value !== AANOptions.OTHER ? "" : AANOtherNotes,
              })
            }
            size="sm"
          >
            <SelectItem key="no-reason" text="Select a reason" value="" />
            {aansOptions}
          </Select>
          {selectedAAN === AANOptions.OTHER && (
            <TextInput
              id="other-income-notes"
              name="notes"
              size="sm"
              value={AANOtherNotes}
              labelText="Other, please specify"
              placeholder="Enter a reason"
              type="text"
              onChange={e => this.setState({ AANOtherNotes: e.target.value })}
            />
          )}
        </Modal>
        <div key="pending_aans" className="hurdles-editor__group">
          <h4 className={headerClassNames}>Adverse Action Notifications</h4>
          <table className="table table-striped table-hover hurdles-editor__table">
            <thead>
              <tr id="scheduled_aans_header">
                <th>Reasons</th>
                <th>Status</th>
                {!this.aANHasBeenSent() && <th>Actions</th>}
              </tr>
            </thead>
            {!this.aANHasBeenSent() && (
              <tfoot>
                <tr>
                  <td>
                    <Button
                      kind="primary"
                      onClick={() => {
                        this.setState({ modalIsOpen: true });
                      }}
                    >
                      Create AAN
                    </Button>
                  </td>
                  <td />
                  <td />
                </tr>
              </tfoot>
            )}
            <tbody key="scheduled_aan_metas">
              {this.state.aans.map((aan, index) => (
                <tr key={`aan_${index}`}>
                  <td>
                    <ul className="aan_scheduler__reasons_list">
                      {aan.reasons && aan.reasons.map((reason, i) => <li key={i}>{reason}</li>)}
                    </ul>
                  </td>
                  <td>
                    <ul>
                      {aan.created_at && (
                        <li>
                          <FormattedDate
                            value={aan.created_at}
                            year="numeric"
                            month="numeric"
                            day="numeric"
                            hour="numeric"
                            minute="numeric"
                          />
                          : created by {aan.created_by_email}
                        </li>
                      )}
                      {aan.cancelled_at && (
                        <li>
                          <FormattedDate
                            value={aan.cancelled_at}
                            year="numeric"
                            month="numeric"
                            day="numeric"
                            hour="numeric"
                            minute="numeric"
                          />
                          : cancelled by {aan.cancelled_by_email}
                        </li>
                      )}
                      {aan.confirmed_at && (
                        <li>
                          <FormattedDate
                            value={aan.confirmed_at}
                            year="numeric"
                            month="numeric"
                            day="numeric"
                            hour="numeric"
                            minute="numeric"
                          />
                          : confirmed by {aan.confirmed_by_email}
                        </li>
                      )}
                      {aan.sent_at && (
                        <li>
                          <FormattedDate
                            value={aan.sent_at}
                            year="numeric"
                            month="numeric"
                            day="numeric"
                            hour="numeric"
                            minute="numeric"
                          />
                          : sent
                        </li>
                      )}
                    </ul>
                  </td>
                  {!this.aANHasBeenSent() && (
                    <td>
                      {!aan.confirmed_at && !aan.cancelled_at && (
                        <div className="button-menu">
                          <Button
                            danger
                            size="sm"
                            kind="secondary"
                            onClick={this.deleteAAN.bind(this, aan.id)}
                          >
                            Cancel AAN
                          </Button>
                          <Button
                            size="sm"
                            kind="primary"
                            onClick={this.confirmAAN.bind(this, aan.id, true)}
                          >
                            Confirm AAN
                          </Button>
                        </div>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  }
}
export default AAN;
